import { render, staticRenderFns } from "./TelnyxChannels.vue?vue&type=template&id=de0e2d56&scoped=true"
import script from "./TelnyxChannels.vue?vue&type=script&lang=js"
export * from "./TelnyxChannels.vue?vue&type=script&lang=js"
import style0 from "./TelnyxChannels.vue?vue&type=style&index=0&id=de0e2d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0e2d56",
  null
  
)

export default component.exports